export const meetingData = [
	{
		title: "Mid-term Exam Meeting",
		type: "current",
		duration: "None",
		participants: 10,
		date: "5.00 pm - 14 June 2019",
		action: "edit"
	},
	{
		title: "Final Exam Meeting",
		type: "current",
		duration: "None",
		participants: 15,
		date: "4.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Sudden Meeting",
		type: "upcoming",
		duration: "None",
		participants: 20,
		date: "12.00 pm - 04 Feb 2019",
		action: "edit"
	},
	{
		title: "Improvement Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 13,
		date: "11.00 am - 04 March 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "3.00 pm - 14 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "3.00 pm - 04 April 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "upcoming",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	},
	{
		title: "Mid-term Exam Meeting",
		type: "previous",
		duration: "2 hours",
		participants: 15,
		date: "5.00 pm - 04 July 2019",
		action: "edit"
	}
];
